//LIST OF FORM TYPES AVAILABLE;

export const PRODUCTS = "products";
export const PRICECAMPAIGN = "priceCampaign";
export const PRICERULE = "pricerule";
export const GROUPLIST = "groupList";
export const ANALYTICS = "ANALYTICS";
